// Shared singleton loader for Google Maps JS SDK + Places library.
// Ensures the <script> tag is appended once per page, even across React
// StrictMode double-renders or multiple components mounting in parallel.

const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

let _promise = null;

export const loadGoogleMapsPlaces = () => {
  if (_promise) return _promise;
  if (typeof window !== "undefined" && window.google?.maps?.places) {
    _promise = Promise.resolve(window.google);
    return _promise;
  }
  _promise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-doozygo-maps-places="1"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google));
      existing.addEventListener("error", reject);
      if (window.google?.maps?.places) resolve(window.google);
      return;
    }
    const cbName = "__doozygoMapsPlacesReady";
    window[cbName] = () => resolve(window.google);
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_KEY}&libraries=places&callback=${cbName}`;
    s.async = true;
    s.defer = true;
    s.dataset.doozygoMapsPlaces = "1";
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return _promise;
};

// Extract a 6-digit postal code from a Places result's address_components.
export const extractPincode = (place) => {
  const comps = place?.address_components || [];
  const pin = comps.find((c) => c.types?.includes("postal_code"));
  return pin?.long_name || "";
};
